import { render, staticRenderFns } from "./contactCenSqzx.vue?vue&type=template&id=61601826&scoped=true"
import script from "./contactCenSqzx.vue?vue&type=script&lang=js"
export * from "./contactCenSqzx.vue?vue&type=script&lang=js"
import style1 from "./contactCenSqzx.vue?vue&type=style&index=1&id=61601826&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61601826",
  null
  
)

export default component.exports